import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import EventsRequests from "services/events";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddEventTokenDialog({ open, handleClose, item }) {
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [token, setToken] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    if (item) {
      setName(item.name);
      setDesc(item.description);
      setToken(item.token);
    }
    return () => {
      reset();
    };
  }, [item]);

  const handleAddEventToken = () => {
    const data = {
      name: name,
      description: desc,
      token: token,
    };
    if (item) {
      dispatch(EventsRequests.updateEventTicketToken(item._id, data));
    } else {
      dispatch(EventsRequests.createSingleEventToken(data));
    }
    handleClose();
    reset();
  };

  const reset = () => {
    setName("");
    setDesc("");
    setToken("");
  };

  const addAccessContent = (
    <GridContainer className={classes.girdContainer}>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>نام</Typography>
        <TextField
          id="nameInput"
          label="نام"
          variant="outlined"
          className={classes.customInput}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>توضیحات</Typography>
        <TextField
          id="nameInput"
          label="توضیحات"
          variant="outlined"
          className={classes.customInput}
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>توکن</Typography>
        <TextField
          id="nameInput"
          label="توکن"
          variant="outlined"
          className={classes.customInput}
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
      </Grid>
    </GridContainer>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          {item ? "ویرایش توکن" : "اضافه کردن توکن"}
        </DialogContentText>
        {addAccessContent}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddEventToken} color="primary">
          {item ? "ویرایش" : "اضافه کردن"}
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
